<template>
  <div class="flex items-center justify-between">

    <!-- Left -->
    <div>
      <p class="text-xs font-bold text-slate-500 uppercase tracking-tight">
        {{ title }}
      </p>

      <p class="text-2xl font-black text-slate-900 mt-1">
        {{ value }}
      </p>
    </div>

    <!-- Right Icon -->
    <div
      class="w-10 h-10 rounded-lg bg-slate-50 flex items-center justify-center"
    >
      <span
        class="material-symbols-outlined text-xl"
        :class="color"
      >
        {{ icon }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String,
    icon: String,
    color: String
  }
};
</script>
